import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const RuleInfo = ({ c }) => {
  const g = c.guidance || {};
  const stop = (e) => e.stopPropagation();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <span role="button" tabIndex={0} aria-label={`What ${c.id} means`} onClick={stop} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.click()}
          className="inline-flex cursor-pointer align-middle text-blue-500 hover:text-blue-700" data-testid={`rule-info-${c.id}`}><Info className="h-3.5 w-3.5" /></span>
      </PopoverTrigger>
      <PopoverContent onClick={stop} className="w-80 space-y-2 text-xs leading-relaxed text-slate-700" data-testid={`rule-info-content-${c.id}`}>
        <div className="font-semibold text-slate-900">{c.id} · {c.name}</div>
        <div><b>What this means:</b> {g.plain_language || c.why_it_matters || "—"}</div>
        {(g.risk_impact || c.why_it_matters) && <div><b>Why it matters:</b> {g.risk_impact || c.why_it_matters}</div>}
        {g.what_to_do?.length > 0 && <div><b>For example, you would:</b> {g.what_to_do[0]}</div>}
        {c.evidence_required?.length > 0 && <div><b>Evidence usually expected:</b> {c.evidence_required.slice(0, 3).join("; ")} <span className="text-slate-400">— asked for so a reviewer can verify the control is really in place.</span></div>}
        <div className="text-[10px] text-slate-400">Plain-language summary, not legal advice. The official requirement text prevails.</div>
      </PopoverContent>
    </Popover>
  );
};
